<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Data Topik Grammar</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Data
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Tambah Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.top_desc`]="{ item }">
                            <div
                              class="text-truncate"
                              style="max-width: 400px;">
                              {{ item.top_desc }}
                            </div>
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editData(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formadddata"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="adddatas.top_title"
                                :rules="[rules.required]"
                                label="Judul Topik"
                                name="top_title"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <ckeditor
                                :editor="editor"
                                :config="editorConfig"
                                v-model="adddatas.top_desc"
                                :rules="[rules.required]">
                              </ckeditor>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.data"
      v-if="dmodaldata.data">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update data grammar</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatedata"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.data.top_title"
                        :rules="[rules.required]"
                        label="Judul"
                        name="istilahen"
                        required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <ckeditor
                        :editor="editor"
                        :config="editorConfig"
                        v-model="dmodaldata.data.top_desc"
                        :rules="[rules.required]">
                      </ckeditor>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statusdata"
                        v-model="dmodaldata.data.top_status"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="dmodal.data = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'TopicAdmin',
  data: () => ({
    editor: ClassicEditor,
    editorConfig: {
      toolbar: {
        shouldNotGroupWhenFull: true,
      },
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertcheck: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      impcheck: false,
      impsubmit: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Judul', value: 'top_title' },
      { text: 'Materi', value: 'top_desc' },
      { text: 'Status', value: 'top_status' },
      { text: 'View', value: 'top_count' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    headerimp: [
      { text: 'Istilah en', value: 'vocab_en' },
      { text: 'Istilah id', value: 'vocab_id' },
      { text: 'Deskripsi en', value: 'desc_en' },
      { text: 'Deskripsi id', value: 'desc_id' },
    ],
    datalist: [],
    adddatas: {
      top_title: '',
      top_desc: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    impdata: {
      file: null,
      data: [],
      search: '',
    },
    impresult: null,
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
    },
    tabdata: null,
    dmodal: {
      data: false,
    },
    dmodaldata: {
      data: null,
    },
    urltemplate: '',
    testmodel: '',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getData();
    this.$store.commit('UPDATE_TITLE', 'Data Grammar');
    this.urltemplate = this.api + '/upload/template/importdata.xlsx';
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getData() {
      this.loading.getdata = true;
      this.datalist = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/grammar/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/grammar/',
              qs.stringify(
                this.adddatas,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formadddata.reset();
                  this.adddatas.top_desc = '';
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Topik "' + resdata.data + '" berhasil ditambahkan!';
                  this.getData();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'kamus') {
        this.dmodal.kamus = false;
      } else {
        this.dmodal.kamus = false;
      }
    },
    editData(item) {
      this.alertupdate.show = false;
      this.dmodal.data = true;
      this.dmodaldata.data = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatedata.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/grammar/',
              qs.stringify(
                this.dmodaldata.data,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = 'Topik "' + this.dmodaldata.data.top_title + '" berhasil diubah!';
                  this.getData();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    uploadDataCheck() {
      this.impdata.data = [];
      this.loading.impcheck = true;
      this.alertcheck.show = false;
      if (this.tokenscr && this.impdata.file) {
        const dataadd = this.impdata;
        const formData = new FormData();
        // file
        formData.append('file_upload', dataadd.file);
        this.axios
          .post(
            this.api + '/api/kamus/uploadcheck',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  // console.log(resdata.data);
                  let datalist = null;
                  for (let i = 1; i < resdata.data.length; i++) {
                    datalist = {
                      vocab_en: resdata.data[i][0],
                      vocab_id: resdata.data[i][1],
                      desc_en: resdata.data[i][2],
                      desc_id: resdata.data[i][3],
                    };
                    this.impdata.data.push(datalist);
                  }
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = resdata.message;
              }
            } else {
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            }
            this.loading.impcheck = false;
          })
          .catch((error) => {
            this.loading.impcheck = false;
            this.alertcheck.show = true;
            this.alertcheck.type = 'error';
            this.alertcheck.text = 'Internal services error!';
          });
      } else {
        this.loading.impcheck = false;
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Invalid data!';
      }
    },
    clearDataRes() {
      this.impdata.data = [];
      this.impdata.search = '';
      this.impdata.file = null;
      this.impresult = null;
    },
    importData() {
      this.alertcheck.show = false;
      this.impresult = null;
      if (this.impdata.data.length > 0) {
        this.loading.impsubmit = true;
        // console.log(this.impdata.data);
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/kamus/import',
              qs.stringify(
                {
                  listdata: this.impdata.data,
                },
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.impresult = resdata.data;
                  this.getData();
                  // console.log(this.impresult);
                } else {
                  this.alertcheck.show = true;
                  this.alertcheck.type = 'error';
                  this.alertcheck.text = resdata.message;
                }
              } else {
                this.alertcheck.show = true;
                this.alertcheck.type = 'error';
                this.alertcheck.text = 'Internal services error!';
              }
              this.loading.impsubmit = false;
            })
            .catch((error) => {
              this.loading.impsubmit = false;
              this.alertcheck.show = true;
              this.alertcheck.type = 'error';
              this.alertcheck.text = 'Internal services error!';
            });
        } else {
          this.loading.impsubmit = false;
          this.alertcheck.show = true;
          this.alertcheck.type = 'error';
          this.alertcheck.text = 'Invalid token!';
        }
      } else {
        this.alertcheck.show = true;
        this.alertcheck.type = 'error';
        this.alertcheck.text = 'Data kosong!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
